import { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';
import Lottie from 'lottie-react';
import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import NoDataAnimationData from './no-data-1.json';

interface INoDataAnimationProps extends StackProps {
	message?: ReactNode;
	messageProps?: TypographyProps;
	lottieContainerStyle?: CSSProperties;
}

export const NoDataAnimation: FC<PropsWithChildren<INoDataAnimationProps>> = ({
	message,
	messageProps: { sx: messageSx, ...messageProps } = {},
	lottieContainerStyle,
	children,
	sx,
	...props
}) => {
	return (
		<Stack
			direction="column"
			spacing={1}
			alignItems="center"
			justifyContent="center"
			sx={{ height: 1.0, boxSizing: 'border-box', ...sx }}
			{...props}
		>
			<Lottie animationData={NoDataAnimationData} loop style={{ maxHeight: 200, ...lottieContainerStyle }} />
			{message ? (
				<Typography variant="body1" sx={{ textAlign: 'center', ...messageSx }} {...messageProps}>
					{message}
				</Typography>
			) : null}
			{children}
		</Stack>
	);
};
